import { render, staticRenderFns } from "./BudgetLegends.vue?vue&type=template&id=8b1a319a&"
import script from "./BudgetLegends.vue?vue&type=script&lang=js&"
export * from "./BudgetLegends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports